import React, { Component } from 'react';
import {
  TextArea, Button, FileUpload, Tag, PopOver, Snackbar, Confirm
} from "@cgn/framework-ui-components/v1";
import { AttachFileIcon } from "@cgn/framework-ui-components/icons";
import Voto from './Voto';

class InviaRisposta extends Component {

  state = {
    mostraVota: false,
    uploadFile: false
  }

  mostra = () => {
    if (this.props.ultimoMessaggioUtente) {
      Confirm("Attenzione",
        <span>Stai per votare un quesito al quale hai appena replicato. <br /><strong>Se hai inviato una domanda non otterrai alcuna risposta</strong></span>,
        'warning',
        null,
        "support__externalMenuConfermaReplica").then(() => {
        this.setState({ mostraVota: true });
      });
    } else {
      this.setState({ mostraVota: !this.state.mostraVota });
    }
  }

  allowUpload = file => {
    var nonPresente = this.props.allegatiRisposta.filter(x => x.nomeFile == file.name).length == 0;

    if (!nonPresente) {
      Snackbar.show({ type: Snackbar.Types.ERROR, message: "Hai già caricato questo file" });
    }

    return nonPresente;
  }

  render() {
    return (<div>
      <div className="quesiti__rispondi" onClick={() => this.areaRispondi.refTextArea.focus()}>
        <TextArea title="Scrivi qui il tuo messaggio" value={this.props.risposta}
          onChange={v => this.props.onRispostaModificata(v)}
          ref={textArea => this.areaRispondi = textArea} />
      </div>
      <div className="quesiti__actionsContainer">
        <div className="quesiti__allegati">
          {this.props.allegatiRisposta.map((x, i) => <Tag key={i} info onClose={() => this.props.onRimuoviAllegato(x.idAllegato)}>{x.nomeFile}</Tag>)}
        </div>
        <div className="quesiti__actionsRispondi">
          <FileUpload
            max={8}
            onChange={() => {
              this.setState({ uploadFile: true });
              Snackbar.creaOperazioneMassiva({ type: Snackbar.Types.MASSIVA, id: 1, message: "Upload allegato in corso...", selezionati: 1 });
            }}
            allowUpload={this.allowUpload}
            url={this.props.uploadUrl}
            onFileUploaded={(res, nomeFile) => {
              this.setState({ uploadFile: false });
              this.props.onFileCaricato(res, nomeFile)
            }}>
            <PopOver top content='Allega file'><Button floating ><AttachFileIcon /></Button></PopOver>
          </FileUpload>

          {this.props.haAlmenoUnaRisposta && <Button flat onClick={(e) => { e.preventDefault(); this.mostra(); }}> Vota e chiudi </Button>}

          <Voto show={this.state.mostraVota}
            voto={this.props.pratica.Voto}
            idPratica={this.props.pratica.IdPratica}
            onVota={(idPratica, voto, commento) => this.props.onVota(idPratica, voto, commento).then(res => this.setState({ mostraVota: false }))}
            onClose={() => this.setState({ mostraVota: false })} />
          <Button disabled={this.state.uploadFile} primary onClick={() => this.props.onRispondi()}>Rispondi</Button>
        </div>
      </div>
    </div>);
  }
}

export default InviaRisposta;